// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"7yuPK":[function(require,module,exports) {
var _common = require("./common");
var trans;
$("document").ready(function() {
    translatePage();
    initClickListeners();
    window.onclick = function(event) {
        if (!event.target.matches(".dropbtn")) {
            var dropdowns = document.getElementsByClassName("dropdown-content");
            var i;
            for(i = 0; i < dropdowns.length; i++){
                var openDropdown = dropdowns[i];
                if (openDropdown.classList.contains("show")) openDropdown.classList.remove("show");
            }
        }
    };
    setActiveList();
    $(window).scroll(function() {
        setActiveList();
    });
});
function setActiveList() {
    var windowPos = $(window).scrollTop() + 90;
    $('.stSection li a[href^="#"]').each(function() {
        var currentLink = $(this);
        if ($(currentLink.attr("href")).length > 0) {
            var refElement = $(currentLink.attr("href"));
            if (refElement.position().top <= windowPos && refElement.position().top + refElement.height() + $(".stSection").height() > windowPos) {
                $(".stSection li a").removeClass("active");
                currentLink.addClass("active");
            } else currentLink.removeClass("active");
        }
    });
}
function openNav() {
    document.getElementById("closeNav").style.display = "block";
    var sidePanel = document.getElementById("resTopnav");
    sidePanel.style.display = "block";
}
function initClickListeners() {
    myTopnav.querySelector(".icon").addEventListener("click", function() {
        openNav();
    });
    btnTranslate.addEventListener("click", function() {
        showDropdown();
    });
    aEn.addEventListener("click", function() {
        translatePage("en");
    });
    aEs.addEventListener("click", function() {
        translatePage("es");
    });
    document.getElementById("closeNav").addEventListener("click", function() {
        closeNav();
    });
}
function showDropdown() {
    document.getElementById("langDropdown").classList.toggle("show");
}
function closeNav() {
    var sidePanel = document.getElementById("resTopnav");
    sidePanel.style.display = "none";
// sidePanel.style.width = "0";
// sidePanel.style.overflow = "hidden";
}
var language = {
    eng: {
        Chat: "Chat",
        Feat: "Features",
        Download: "Download",
        About: "About",
        idiom: "En",
        a0: "About Us",
        a1: "Our Mission",
        a2: "Privacy Policy",
        a3: "Information Collection",
        a4: "Log Data",
        deletingData: "Deleting data",
        deletingAcc: "Deleting account",
        a5: "Cookies",
        a6: "Service Providers",
        a7: "Security",
        a8: "Terms and Conditions",
        a9: "Attributions",
        a10: "Contact Us",
        infoCole: "Information Collection and Use",
        links: "Links to Other Sites",
        child: "Children's Privacy",
        changes: "Changes to This Privacy Policy",
        terms: "Terms and Conditions",
        changeTerms: "Changes to These Terms and Conditions",
        sumAbout: "ChatMurcianys was born out of an idea to facilitate the way radios hosts connect with their listeners. The name was chosen to honor Rudy Murcianys's father who passed away when he was 10 years of age, leaving with him his passion for music. Music was what kept him on the right path and led him to discover radio stations who offered him opportunities to sing. In 2019, he, with the help of his daughter Hensi, developed ChatMurcianys in an effort to bring people together to share their passion for music as they listen to radio stations from all over the world.",
        sumMission: "Our goal is to connect more and more people who have a love for music and would like to share that passion with others. To do so, we are constantly working to improve upon our free messaging, calling, and audio services. We want to continue to provide people a secure platform in which we are all connected through the power of music.",
        sumPol1: "Murcianys built the ChatMurcianys app as an Ad Supported app.This service is provided by Murcianys at no cost and is intended for use as is.",
        sumPol2: "This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.",
        sumPol3: "If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.",
        sumPol4: "The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at ChatMurcianys unless otherwise defined in this Privacy Policy.",
        infoCol1: "For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your phone number, email, name, contacts in your address book, and you may provide a profile image. While using the app, you may also share with us images, videos, and audio files. The information that we request will be retained by us and used as described in this privacy policy.",
        infoCol2: "The app does use third party services that may collect information used to identify you.",
        infoCol3: "Link to privacy policy of third party service providers used by the app",
        logSum: "We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics. ",
        dataSum: `You may request to know, access, correct, or delete the information
    we have collected from you which may include, but is not limited to,
    your username, videos, images, audios, and in-app messages or
    comments. To submit your request using the the options provide in
    the <a href="#contact">"Contact Us"</a> section below.`,
        dAccSum1: `If you ever wish to delete your account, you may do so through the app or by visiting`,
        dAccSum2: `After deleting your account:`,
        dAccSum3: `Once you delete your account it cannot be undone.`,
        dAccSum4: `If you require other account assistance on ChatMurcianys, you can
    contact us at`,
        dAccLi1: `You will no longer be able to log in to ChatMurcianys with that
    account`,
        dAccLi2: `You will lose access to any media you have posted (photos, videos,
      audios)`,
        dAccLi3: `Any radio station or podcast you have registered with us will be
    removed from our database`,
        dAccLi4: `Private or public messages you sent or received may still be
    visible to others`,
        cookieSum1: "Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.",
        cookieSum2: "This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.",
        servSum: "We may employ third-party companies and individuals due to the following reasons:",
        reason1: "To facilitate our Service;",
        reason2: "To provide the Service on our behalf;",
        reason3: "To perform Service-related services; or",
        reason4: "To assist us in analyzing how our Service is used.",
        reasonP: "We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.",
        securitySum: "We value your trust in providing us your Personal Information, thus we are striving to use commercially a cceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.",
        otherSum: "This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.",
        childSum: "These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.",
        changesSum: "We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.",
        changesSum2: 'This privacy policy page was created at <a href="">privacypolicytemplate</a>and modified/generated by <a href="">App Privacy Policy Generator</a>',
        termSum1: "By downloading or using the app, these terms will automatically apply to you – you should make sure therefore that you read them carefully before using the app. You’re not allowed to copy, or modify the app, any part of the app, or our trademarks in any way. You’re not allowed to attempt to extract the source code of the app, and you also shouldn’t try to translate the app into other languages, or make derivative versions. The app itself, and all the trade marks, copyright, database rights and other intellectual property rights related to it, still belong to Murcianys.",
        termsSum2: "Murcianys is committed to ensuring that the app is as useful and efficient as possible. For that reason, we reserve the right to make changes to the app or to charge for its services, at any time and for any reason. We will never charge you for the app or its services without making it very clear to you exactly what you’re paying for.",
        termsSum3: "The ChatMurcianys app stores and processes personal data that you have provided to us, in order to provide our Service. It’s your responsibility to keep your phone and access to the app secure. We therefore recommend that you do not jailbreak or root your phone, which is the process of removing software restrictions and limitations imposed by the official operating system of your device. It could make your phone vulnerable to malware/viruses/malicious programs, compromise your phone’s security features and it could mean that the Chat Murcianys app won’t work properly or at all.",
        termsSum4: "You should be aware that there are certain things that Murcianys will not take responsibility for. Certain functions of the app will require the app to have an active internet connection. The connection can be Wi-Fi, or  provided by your mobile network provider, but Murcianys cannot take responsibility for the app not working at full functionality if you don’t have access to Wi-Fi, and you don’t have any of your data allowance left.",
        termsSum5: "If you’re using the app outside of an area with Wi-Fi, you should remember that your terms of the agreement with your mobile network provider will still apply. As a result, you may be charged by your mobile provider for the cost of data for the duration of the connection while accessing the app, or other third party charges. In using the app, you’re accepting responsibility for any such charges, including roaming data charges if you use the app outside of your home territory (i.e. region or country) without turning off data roaming. If you are not the bill payer for the device on which you’re using the app, please be aware that we assume that you have received permission from the bill payer for using the app.",
        termsSum6: "Along the same lines, Murcianys cannot always take responsibility for the way you use the app i.e. You need to make sure that your device stays charged – if it runs out of battery and you can’t turn it on to avail the Service, Murcianys cannot accept responsibility.",
        termsSum7: "With respect to Murcianys’s responsibility for your use of the app, when you’re using the app, it’s important to bear in mind that although we endeavour to ensure that it is updated and correct at all times, we do rely on third parties to provide information to us so that we can make it available to you. Murcianys accepts no liability for any loss, direct or indirect, you experience as a result of relying wholly on this functionality of the app.",
        termsSum8: "At some point, we may wish to update the app. The app is currently available on Android and iOS – the requirements for system (and for any additional systems we decide to extend the availability of the app to) may change, and you’ll need to download the updates if you want to keep using the app. Murcianys does not promise that it will always update the app so that it is relevant to you and/or works with the Android/iOS version that you have installed on your device. However, you promise to always accept updates to the application when offered to you, We may also wish to stop providing the app, and may terminate use of it at any time without giving notice of termination to you. Unless we tell you otherwise, upon any termination, (a) the rights and licenses granted to you in these terms will end; (b) you must stop using the app, and (if needed) delete it from your device.",
        changesTermSum: "We may update our Terms and Conditions from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Terms and Conditions on this page. These changes are effective immediately after they are posted on this page.",
        contactSum1: 'If you have any questions or suggestions about our privacy policy or Terms and Conditions, do not hesitate to contact us at <a href="mailto:info@chatmurcianys.com">info@chatmurcianys.com</a>.',
        contactSum2: "This Terms and Conditions page was generated by",
        coinsPolicy: "Coins Policy",
        giftsPolicy: "Gifts Policy",
        wdPolicy: "Withdrawal Policy",
        coinsCP1: `This Coins Policy describes the terms and conditions that govern
    the purchase and use of Coins on ChatMurcianys. The purchase and
    use of Coins on ChatMurcianys is entirely voluntary.`,
        coinsCP2: `Purchase qualifications and security`,
        coinsCP3: `To make a purchase on ChatMurcianys, you must be a registered
    ChatMurcianys user and comply with this Coins Policy (including
    the <a href="#privacy">Privacy Policy</a> and the
    <a href="#terms">Terms and Conditions</a> policy. You acknowledge
    that you are responsible for maintaining the security of, and
    restricting access to, your account and password. You also agree
    to accept responsibility for all purchases and other activities
    that occur under your account. ChatMurcianys sells its Ancillary
    Products and Services only to those users who can legally make
    purchases with a credit card. If you are between the ages of 13
    and 18 (or the legal age of majority in your state of residence),
    you may make purchases on ChatMurcianys only with the permission
    of a parent or guardian. ChatMurcianys reserves the right to
    refuse, cancel orders, or terminate accounts, at any time in its
    sole discretion.`,
        coinsCP4: `ChatMurcianys may offer certain Ancillary Products and Services
    such as Coins, which are digital items (virtual currency) that
    allow users to activate or access other virtual items or services
    on the Platform that may be available on the Platform from time to
    time. Coins have no monetary value (i.e., are not a cash account
    or equivalent), and do not constitute currency or property of any
    type. Coins cannot be sold or transferred to other Users, and
    cannot be exchanged for cash or for any other goods and services.
    Users have no property, proprietary, intellectual property,
    ownership, or monetary interest in promotional or purchased Coins,
    which remain ChatMurcianys digital content subject to
    ChatMurcianys <a href="#terms">Terms and Conditions</a>. Coins are
    non-refundable. ChatMurcianys does not recognize the transfer of
    Coins (including for money or any other consideration or items of
    value whether inside or outside ChatMurcianys). You may not
    purchase, sell, barter, or trade any Coins, or offer to purchase,
    sell, or trade any Coins. Any such attempted transfer will be null
    and void. Coins can only be used on ChatMurcianys as a way to
    activate or access other virtual items or services that may be
    available on ChatMurcianys from time to time.`,
        coinsCP5: `ChatMurcianys does not guarantee that Coins will be available at
    all times or at any given time. ChatMurcianys does not guarantee
    that we will continue to offer Coins for any particular length of
    time. ChatMurcianys may modify Coins at our sole discretion, and
    such modifications may make Coins more or less common, desirable,
    effective, or functional. ChatMurcianys may suspend or terminate
    Coins for any or no reason in our sole discretion, and without
    advance notice or liability.`,
        coinsCP6: `The number of coins that are needed to activate or access Virtual
    Items (Gifts) will be displayed to you when attempting to purchase
    such Gifts. Before buying Coins, check how many you need. The cost
    per Coin differs depending on how many you buy at one time. We
    will make the total price of the Coin package clear to you when
    you are buying Coins. You can track your spending on Coins, and
    how you use them to access Gifts, using the following tools:`,
        coinsTL1: `The total number of coins (Coin Balance) will be updated each
    time you purchase Coins or use them in exchange for Virtual
    items. Your account balance is shown in the menu of your Home
    Page (<i class="fa-solid fa-bars"></i> > Balance > Recharges)
    and at any time you are about to use Coins to activate or access
    virtual items;`,
        coinsTL2: `In your Balance, you can view your Recharges history which shows
    you how many Coins you have purchased;`,
        coinsTL3: `In the Gifts section of your balance, you can also view how you
    have used Coins on ChatMurcianys by selecting the Sent option.`,
        coinsCP7: `Sending Gifts`,
        coinsCP8: `Gifts are virtual items that can be activated using Coins`,
        coinsCP9: `You can send Gifts to interact with and show your appreciation for
    the content on ChatMurcianys in accordance with our
    <a href="#terms">Terms and Conditions</a>. When yous send a Gift,
    other users on ChatMurcianys can see your username, profile image
    (if provided) and the details of the Gift that you sent. By
    sending Gifts, you are not transferring money to other users of
    ChatMurcianys. Instead, the type and number of Gifts sent is a
    factor used by ChatMurcianys in calculating the amount of Rubies
    that will be awarded to the creators of such content, along with
    other factors, which may apply if any. Rubies can be used to
    obtain money from ChatMurcianys in accordance with our
    <a href="#gifts-policy">Gifts Policy</a>`,
        coinsCP10: `Because Gifts are automatically activated with immediate effect,
    they are not returnable or refundable for either Coins or money.`,
        coinsCP11: `Purchasing Coins`,
        coinsCP12: `Coins can be purchased through a third party app store (Google
      Play Store). ChatMurcianys may allow for additional ways to obtain
      Coins at its discretion.`,
        coinsCP13: `In the case that the incorrect amount of Coins is credited to your
      account Balance, you may contact us and we will correct the
      mistake as soon as possible.`,
        coinsCP14: `If an issue occurs with your payment method (payment is declined)
      your order will be cancelled automatically. We are not responsible
      for any issues between you and your card issuer, bank, or other
      payment service provider.`,
        coinsCP15: `If you purchase Coins through a third party app store (Google Play
        Store), then applicable store's terms of in-app purchases apply.`,
        coinsCP16: `Refunds`,
        coinsCP17: `If you purchased Coins through a third party app store (Google
      Play Store), then you will need to contact the relevant app store
      about refunds. ChatMurcianys cannot provide you with a refund
      unless the Coins are defective. To withdraw from your purchase of
      Coins, please contact us so that we may help with any errors you
      may be facing with the purchase of the Coins.`,
        giftsCP1: `This Gifts Policy applies to users of ChatMurcianys that
      participate in the Gifting program that incentivise users to
      interact with ChatMurcianys. "Gifts" means digital content such as
      Rubies and emoticons that may be available;`,
        giftsCP2: `Eligibility`,
        giftsCP3: `To participate in the program you must be at least 13 years of age
    and register a valid Radio Station and must be approved by
    ChatMurcianys. Other eligible participation options may be
    available in the future. If you are between the ages of 13 and 18
    (or between 13 and the age of legal majority in your country of
    residence) , you may only participate in the Program under the
    supervision of a parent or legal guardian who agrees to be bound
    by this Agreement. We will determine your eligibility at our sole
    discretion. Approved Radio Station owners will have the option to
    participate in the program by announcing their live broadcast on
    ChatMurcianys (Announce live broadcast) and checking the "Allow
    audience to send gifts" option.`,
        giftsCP4: `If we decide to reject you participation or terminate your account
    in connection with any violations or abuse, including, but not
    limited to any violations of the
    <a href="#terms">Terms and Conditions</a> and the Community
    Guidelines as stated in the
    <a href="#privacy">Privacy Policy</a> you cannot attempt to
    re-join the Program without our advance written authorization.`,
        giftsCP5: `Compliance requirements`,
        giftsCP6: `You will ensure that the information associated with your account
    are at all times complete, accurate, and up-to-date. You must also
    comply with our <a href="#terms">Terms and Conditions</a> and
    <a href="#privacy">Privacy Policy</a>. In addition, you agree to
    the following compliance agreements with our current Gifting
    eligible Programs:`,
        giftsE1: `Radio Stations:`,
        giftsE2: `The Owner and/or Hosts of the Radio Station will be the only
    ones who will be able to receive and claim the Gifts gifted by
    their audience through ChatMurcianys. The words Owner and
    Hosts refers to anyone who has a direct association or has a
    role with the operation of the Radio Station's entity. That
    is, they are the user who registered the Radio Station, the
    user(s) who administer, manage, or host the Radio Station and
    who have permission (as expressed and professed by the Owner
    of the Radio Station through ChatMurcianys's platform) to
    engage with the Radio Station's identity.`,
        giftsE3: `ChatMurcianys, in its sole discretion, may make Gifts
    available to you to display, present or otherwise use in your
    chat room, or by other means. These gifts will be used to
    support your Radio Station's broadcast to celebrate moments
    and express appreciation for the host using the "Send Gift"
    feature on ChatMurcianys.`,
        giftsCP7: `The gifts received will be converted into Rubies. When the Gifts
    are in Rubies, they can be used to obtain money. You will receive
    one U.S. cent ($0.01) per Ruby that is used by an user to express
    their support to you through chat, or other means through
    ChatMurcianys. The Gifts Policy may be adjusted by ChatMurcianys
    from time, in its sole discretion, including, for Rubies received
    by users on a promotional basis, purchased in different local
    jurisdictions or as otherwise required to prevent harm to
    ChatMurcianys's business interests. In addition, ChatMurcianys may
    determine not to provide you with Rubies for any use of Rubies
    that is not consistent with the Gifts Policy. ChatMurcianys
    reserves the right to stop offering or supporting Gifts and/or
    Rubies at any time.`,
        wdCP1: `This Withdrawal Policy applies to Users of ChatMurcianys that
    participate in the Gift Program and choose to withdraw their
    earnings (Rubies) through ChatMurcianys.`,
        wdCP2: `To withdraw your earnings, you must use one of the withdrawal
    methods that we currently support:`,
        wdCP3: `The payment will be sent to the external account you select in
    accordance with the rules of the payment method provider. We
    reserve the right to require this account to be registered in your
    own name. You are subject to all terms and conditions of the
    payment method you choose. All payments are to be made in the
    United States Dollars, except where other currencies are offered
    via the payment methods made available by ChatMurcianys.`,
        wdCP4: `You must make sure that the information you provide is accurate,
    complete, and up-to-date. You will be solely responsible for any
    consequences resulting from providing inaccurate or incomplete
    information. We may verify your payment information and
    eligibility to collect Rubies or receive payments, such as
    identity, age, and location. If additional information is
    required, you agree to provide us with such information upon
    request.`,
        wdCP5: `The following withdrawal minimum and maximum apply:`,
        wdM1: `Minimum withdrawal:`,
        wdM2: `Paypal: $50.00`,
        wdM3: `Zelle: $50.00`,
        wdM4: `Maximum daily withdrawal is equivalent to $1,000 in United
    States Dollars`,
        wdCP6: `Transaction fees`,
        wdCP7: `The external withdrawal methods that ChatMurcianys currently
    supports may impose an additional transaction fee. If a
    transaction fee is imposed, it will be deducted from each
    withdrawal payment before it lands in the external account of your
    choice.`,
        wdCP8: `We may, for security reasons and/or to maintain the integrity of
    your account, suspend your ability to use Rubies to obtain a
    payment. We will contact you if we have to do this. Where we need
    to make urgent changes for security, safety, legal, or regulatory
    requirements, we may not be able to provide you with advance
    notice, but we will let you know as soon as we are able to. If you
    believe that we have made an error by suspending your ability to
    use Rubies to obtain a payment, then please contact us.`,
        wdCP9: `We are not responsible for any loss or damage caused by payment method providers, provided it is not as a result of our actions.`,
        wdCP10: `All payments will be inclusive of tax (if applicable). If you are
    subject to any taxes on payments, you will be responsible for the
    payment of such taxes.`,
        wdCP11: `We may change or alter this policy at any time for legal,
    regulatory or business reasons. These changes may include who can
    participate in the Gift Program, how payments are collected or
    used. These modifications can be done without prior notice, in
    ChatMurcianys's sole discretion. If changes are made, we may
    provide notice by sending an email, posting a notice on
    ChatMurcianys, or posting on ChatMurcianys's social media. Please
    check these terms periodically for those changes. Any modified
    terms will apply to any purchases made after such changes are
    posted on ChatMurcianys. Therefore, you should review these terms
    prior to each purchase or withdrawal so will understand the terms
    applicable to such transaction. If you do not agree to these
    terms, do not make any purchases or withdrawals on ChatMurcianys.`,
        polUpdated: "Updated: 7/20/2023",
        inaContent: "Inappropriate content",
        inaSum: "To protect the safety, security, and integrity of our services, we will take appropriate action against abusive people or activities that violate our Terms and Conditions. We prohibit misuse of our services and any content that is harmful or inappropriate for our users, including the actions below:",
        spam: "Spam",
        sexualContent: "Sexual content",
        hateSpeech: "Hate Speech",
        violence: "Violence",
        senEvents: "Sensitive events",
        bullying: "Bullying and harrasment",
        dangerProds: "Dangerous products",
        falseinfo: "False information",
        unaSales: "Unauthorized sales"
    },
    es: {
        Chat: "Chat",
        Feat: "Funciones",
        Download: "Descargar",
        About: "Sobre",
        idiom: "Es",
        a0: "Acerca de Nosotros",
        a1: "Nuestra Misi\xf3n",
        a2: "Pol\xedtica de Privacidad",
        a3: "Recopilaci\xf3n de Informaci\xf3n",
        a4: "Datos de Registro",
        deletingData: "Eliminando datos",
        deletingAcc: "Eliminar cuenta",
        a5: "Cookies",
        a6: "Proveedores de Servicio",
        a7: "Seguridad",
        a8: "T\xe9rminos y Condiciones",
        a9: "Atribuciones",
        a10: "Contactanos",
        infoCole: "Recopilaci\xf3n de Informaci\xf3n y Uso",
        links: "Enlaces a otros sitios",
        child: "Privacidad De Los Ni\xf1os",
        changes: "Cambios a esta pol\xedtica de privacidad",
        terms: "T\xe9rminos y Condiciones",
        changeTerms: "Cambios a estos t\xe9rminos y condiciones",
        sumAbout: "ChatMurcianys naci\xf3 de una idea para facilitar la forma en que los anfitriones de radios se conectan con sus oyentes. El nombre fue elegido para honrar al padre de Rudy Murcianys que falleci\xf3 cuando ten\xeda 10 a\xf1os, dejando con \xe9l su pasi\xf3n por la m\xfasica. La m\xfasica fue lo que lo mantuvo en el camino correcto y lo llev\xf3 a descubrir estaciones de radio que le ofrecieron oportunidades para cantar. En 2019, \xe9l, con la ayuda de su hija Hensi, desarroll\xf3 ChatMurcianys en un esfuerzo por unir a las personas para compartir su pasi\xf3n por la m\xfasica mientras escuchan estaciones de radio de todo el mundo.",
        sumMission: "Nuestro objetivo es conectar a m\xe1s y m\xe1s personas que aman la m\xfasica y les gustar\xeda compartir esa pasi\xf3n con los dem\xe1s. Para hacerlo, trabajamos constantemente para mejorar nuestros servicios gratuitos de mensajer\xeda, llamadas y audio. Queremos continuar brindando a las personas una plataforma segura en la que todos estamos conectados a trav\xe9s del poder de la m\xfasica.",
        sumPol1: "Murcianys cre\xf3 la aplicaci\xf3n ChatMurcianys como una aplicaci\xf3n con publicidad. Este servicio es proporcionado por Murcianys sin costo y est\xe1 dise\xf1ado para usarse como est\xe1.",
        sumPol2: "Esta p\xe1gina se utiliza para informar a los visitantes sobre nuestras pol\xedticas con la recopilaci\xf3n, uso y divulgaci\xf3n de informaci\xf3n personal si alguien decide utilizar nuestro servicio.",
        sumPol3: "Si elige usar nuestro Servicio, entonces acepta la recopilaci\xf3n y el uso de informaci\xf3n en relaci\xf3n con esta pol\xedtica. La informaci\xf3n personal que recopilamos se utiliza para proporcionar y mejorar el Servicio. No utilizaremos ni compartiremos su informaci\xf3n con nadie, excepto como se describe en esta Pol\xedtica de privacidad.",
        sumPol4: "Los t\xe9rminos utilizados en esta Pol\xedtica de privacidad tienen el mismo significado que en nuestros T\xe9rminos y condiciones, a los que se puede acceder en ChatMurcianys a menos que se defina lo contrario en esta Pol\xedtica de privacidad.",
        infoCol1: "Para una mejor experiencia, mientras utiliza nuestro Servicio, es posible que le solicitemos que nos brinde cierta informaci\xf3n de identificaci\xf3n personal, incluidos, entre otros, su n\xfamero de tel\xe9fono, correo electr\xf3nico, nombre, contactos en su libreta de direcciones, y puede proporcionar una imagen de perfil. Mientras usa la aplicaci\xf3n, tambi\xe9n puede compartir con nosotros im\xe1genes, videos y archivos de audio. La informaci\xf3n que solicitamos ser\xe1 retenida por nosotros y utilizada como se describe en esta pol\xedtica de privacidad.",
        infoCol2: "La aplicaci\xf3n utiliza servicios de terceros que pueden recopilar informaci\xf3n utilizada para identificarlo.",
        infoCol3: "Enlace a la pol\xedtica de privacidad de los proveedores de servicios externos utilizados por la aplicaci\xf3n",
        logSum: 'Queremos informarle que cada vez que utiliza nuestro Servicio, en caso de un error en la aplicaci\xf3n, recopilamos datos e informaci\xf3n (a trav\xe9s de productos de terceros) en su tel\xe9fono llamados Datos de registro. Estos datos de registro pueden incluir informaci\xf3n como la direcci\xf3n del Protocolo de Internet ("IP") de su dispositivo, el nombre del dispositivo, la versi\xf3n del sistema operativo, la configuraci\xf3n de la aplicaci\xf3n cuando utiliza nuestro Servicio, la hora y la fecha de uso del Servicio y otras estad\xedsticas .',
        dataSum: `Puede solicitar conocer, acceder, corregir o eliminar la información que hemos recopilado de usted, que puede incluir, entre otros, su nombre de usuario, videos, imágenes, audios y mensajes o comentarios en la aplicación. Para enviar su solicitud, use las opciones proporcionadas en la sección <a href="#contact">"Contáctenos"</a> a continuación.`,
        dAccSum1: `Si alguna vez desea eliminar su cuenta, puede hacerlo a través de la aplicación o visitando`,
        dAccSum2: `Después de eliminar su cuenta:`,
        dAccSum3: `Una vez que elimine su cuenta, no se puede revertir`,
        dAccSum4: `Si necesita otra ayuda con su cuenta en ChatMurcianys, puede
     contáctenos en`,
        dAccLi1: `Ya no podrás iniciar sesión en ChatMurcianys con esa cuenta`,
        dAccLi2: `Perderás el acceso a cualquier medio que hayas publicado (fotos, videos, audios)`,
        dAccLi3: `Cualquier estación de radio o podcast que haya registrado con nosotros será eliminado de nuestra base de datos`,
        dAccLi4: `Los mensajes privados o públicos que envió o recibió pueden seguir siendo visibles para otros`,
        cookieSum1: "Las cookies son archivos con una peque\xf1a cantidad de datos que se usan com\xfanmente como identificadores \xfanicos an\xf3nimos. Estos se env\xedan a su navegador desde los sitios web que visita y se almacenan en la memoria interna de su dispositivo.",
        cookieSum2: 'Este servicio no utiliza estas "cookies" expl\xedcitamente. Sin embargo, la aplicaci\xf3n puede usar c\xf3digo de terceros y bibliotecas que usan "cookies" para recopilar informaci\xf3n y mejorar sus servicios. Tiene la opci\xf3n de aceptar o rechazar estas cookies y saber cu\xe1ndo se env\xeda una cookie a su dispositivo. Si elige rechazar nuestras cookies, es posible que no pueda usar algunas partes de este Servicio.',
        servSum: "Podemos emplear a empresas e individuos de terceros debido a las siguientes razones:",
        reason1: "Para facilitar nuestro servicio;",
        reason2: "Para proporcionar el Servicio en nuestro nombre;",
        reason3: "Para realizar servicios relacionados con el Servicio; o",
        reason4: "Para ayudarnos a analizar c\xf3mo se utiliza nuestro Servicio.",
        reasonP: "Queremos informar a los usuarios de este Servicio que estos terceros tienen acceso a su Informaci\xf3n personal. La raz\xf3n es realizar las tareas que se les asignaron en nuestro nombre. Sin embargo, est\xe1n obligados a no divulgar ni utilizar la informaci\xf3n para ning\xfan otro prop\xf3sito.",
        securitySum: "Valoramos su confianza en proporcionarnos su informaci\xf3n personal, por lo tanto, nos esforzamos por utilizar comercialmente un medio aceptable para protegerla. Pero recuerde que ning\xfan m\xe9todo de transmisi\xf3n por Internet o m\xe9todo de almacenamiento electr\xf3nico es 100% seguro y confiable, y no podemos garantizar su seguridad absoluta.",
        otherSum: "Este servicio puede contener enlaces a otros sitios. Si hace clic en un enlace de un tercero, ser\xe1 dirigido a ese sitio. Tenga en cuenta que estos sitios externos no son operados por nosotros. Por lo tanto, le recomendamos encarecidamente que revise la Pol\xedtica de privacidad de estos sitios web. No tenemos control ni asumimos ninguna responsabilidad por el contenido, las pol\xedticas de privacidad o las pr\xe1cticas de sitios o servicios de terceros.",
        childSum: "Estos Servicios no se dirigen a ninguna persona menor de 13 a\xf1os. No recopilamos a sabiendas informaci\xf3n de identificaci\xf3n personal de ni\xf1os menores de 13 a\xf1os. En el caso de que descubramos que un ni\xf1o menor de 13 a\xf1os nos ha proporcionado informaci\xf3n personal, la eliminamos inmediatamente de nuestros servidores. Si usted es padre o tutor y sabe que su hijo nos ha proporcionado informaci\xf3n personal, cont\xe1ctenos para que podamos realizar las acciones necesarias.",
        changesSum: "Podemos actualizar nuestra Pol\xedtica de privacidad de vez en cuando. Por lo tanto, se recomienda que revise esta p\xe1gina peri\xf3dicamente en busca de cambios. Le notificaremos cualquier cambio publicando la nueva Pol\xedtica de privacidad en esta p\xe1gina. Estos cambios son efectivos inmediatamente despu\xe9s de su publicaci\xf3n en esta p\xe1gina.",
        changesSum2: 'Esta p\xe1gina de pol\xedtica de privacidad fue creada en<a href=""> privacypolicytemplate </a>y modificado / generado por<a href=""> Generador de pol\xedticas de privacidad de aplicaciones </a>',
        termSum1: "Al descargar o usar la aplicaci\xf3n, estos t\xe9rminos se aplicar\xe1n autom\xe1ticamente a usted; por lo tanto, debe asegurarse de leerlos cuidadosamente antes de usar la aplicaci\xf3n. No est\xe1 permitido copiar ni modificar la aplicaci\xf3n, ninguna parte de la aplicaci\xf3n ni nuestras marcas comerciales de ninguna manera. No se le permite intentar extraer el c\xf3digo fuente de la aplicaci\xf3n, y tampoco debe intentar traducir la aplicaci\xf3n a otros idiomas o hacer versiones derivadas. La aplicaci\xf3n en s\xed, y todas las marcas comerciales, derechos de autor, derechos de base de datos y otros derechos de propiedad intelectual relacionados con ella, todav\xeda pertenecen a Murcianys.",
        termsSum2: "Murcianys se compromete a garantizar que la aplicaci\xf3n sea lo m\xe1s \xfatil y eficiente posible. Por esa raz\xf3n, nos reservamos el derecho de realizar cambios en la aplicaci\xf3n o cobrar por sus servicios, en cualquier momento y por cualquier motivo. Nunca le cobraremos por la aplicaci\xf3n o sus servicios sin dejarle muy claro exactamente por lo que est\xe1 pagando.",
        termsSum3: "La aplicaci\xf3n ChatMurcianys almacena y procesa los datos personales que nos ha proporcionado para proporcionar nuestro Servicio. Es su responsabilidad mantener su tel\xe9fono y acceso seguros a la aplicaci\xf3n. Por lo tanto, le recomendamos que no haga jailbreak ni rootee su tel\xe9fono, que es el proceso de eliminar las restricciones y limitaciones de software impuestas por el sistema operativo oficial de su dispositivo. Podr\xeda hacer que su tel\xe9fono sea vulnerable a malware / virus / programas maliciosos, comprometer las caracter\xedsticas de seguridad de su tel\xe9fono y podr\xeda significar que la aplicaci\xf3n Chat Murcianys no funcionar\xe1 correctamente o no funcionar\xe1 en absoluto.",
        termsSum4: "Debe tener en cuenta que hay ciertas cosas de las que Murcianys no se har\xe1 responsable. Ciertas funciones de la aplicaci\xf3n requerir\xe1n que la aplicaci\xf3n tenga una conexi\xf3n a Internet activa. La conexi\xf3n puede ser Wi-Fi o la puede proporcionar su proveedor de red m\xf3vil, pero Murcianys no puede hacerse responsable de que la aplicaci\xf3n no funcione con todas sus funciones si no tiene acceso a Wi-Fi y no tiene ninguno de sus asignaci\xf3n de datos restante.",
        termsSum5: "Si est\xe1 utilizando la aplicaci\xf3n fuera de un \xe1rea con Wi-Fi, debe recordar que sus t\xe9rminos del acuerdo con su proveedor de red m\xf3vil a\xfan se aplicar\xe1n. Como resultado, es posible que su proveedor de servicios m\xf3viles le cobre el costo de los datos durante la conexi\xf3n mientras accede a la aplicaci\xf3n u otros cargos de terceros. Al usar la aplicaci\xf3n, usted acepta la responsabilidad de dichos cargos, incluidos los cargos por datos de roaming si usa la aplicaci\xf3n fuera de su territorio local (es decir, regi\xf3n o pa\xeds) sin desactivar el roaming de datos. Si no es el pagador de facturas del dispositivo en el que est\xe1 utilizando la aplicaci\xf3n, tenga en cuenta que asumimos que ha recibido permiso del pagador de facturas para usar la aplicaci\xf3n.",
        termsSum6: "En la misma l\xednea, Murcianys no siempre puede hacerse responsable de la forma en que usa la aplicaci\xf3n, es decir, debe asegurarse de que su dispositivo se mantenga cargado; si se queda sin bater\xeda y no puede encenderlo para hacer uso del Servicio, Murcianys no puede aceptar la responsabilidad.",
        termsSum7: "Con respecto a la responsabilidad de Murcianys por su uso de la aplicaci\xf3n, cuando la utiliza, es importante tener en cuenta que, aunque nos esforzamos por garantizar que est\xe9 actualizada y sea correcta en todo momento, confiamos en que terceros nos brinden informaci\xf3n para que podamos ponerla a su disposici\xf3n. Murcianys no acepta ninguna responsabilidad por cualquier p\xe9rdida, directa o indirecta, que experimente como resultado de confiar totalmente en esta funcionalidad de la aplicaci\xf3n.",
        termsSum8: "En alg\xfan momento, es posible que deseemos actualizar la aplicaci\xf3n. La aplicaci\xf3n est\xe1 actualmente disponible en Android y iOS: los requisitos para el sistema (y para cualquier sistema adicional al que decidamos extender la disponibilidad de la aplicaci\xf3n) pueden cambiar, y deber\xe1 descargar las actualizaciones si desea seguir utilizando la aplicaci\xf3n. Murcianys no promete que siempre actualizar\xe1 la aplicaci\xf3n para que sea relevante para usted y / o funcione con la versi\xf3n de Android/iOS que haya instalado en su dispositivo. Sin embargo, usted promete aceptar siempre las actualizaciones de la aplicaci\xf3n cuando se le ofrezca. Tambi\xe9n es posible que deseemos dejar de proporcionar la aplicaci\xf3n, y podemos finalizar el uso de la misma en cualquier momento sin avisarle de la finalizaci\xf3n. A menos que le indiquemos lo contrario, en caso de terminaci\xf3n, (a) los derechos y licencias otorgados a usted en estos t\xe9rminos finalizar\xe1n; (b) debe dejar de usar la aplicaci\xf3n y (si es necesario) eliminarla de su dispositivo.",
        changesTermSum: "Podemos actualizar nuestros T\xe9rminos y condiciones de vez en cuando. Por lo tanto, se recomienda que revise esta p\xe1gina peri\xf3dicamente en busca de cambios. Le notificaremos cualquier cambio publicando los nuevos T\xe9rminos y condiciones en esta p\xe1gina. Estos cambios son efectivos inmediatamente despu\xe9s de su publicaci\xf3n en esta p\xe1gina.",
        contactSum1: 'Si tiene alguna pregunta o sugerencia sobre nuestra pol\xedtica de privacidad o los T\xe9rminos y condiciones, no dude en ponerse en contacto con nosotros en <a href="mailto:info@chatmurcianys.com"> info@chatmurcianys.com </a>.',
        contactSum2: "Esta p\xe1gina de T\xe9rminos y Condiciones fue generada por",
        coinsPolicy: "Pol\xedtica de monedas",
        giftsPolicy: "Pol\xedtica de regalos",
        wdPolicy: "Pol\xedtica de retiro",
        coinsCP1: `Esta Política de monedas describe los términos y condiciones que rigen
    la compra y uso de Monedas en ChatMurcianys. La Compra y
    El uso de Monedas en ChatMurcianys es totalmente voluntario.`,
        coinsCP2: `Calificaciones de compra y seguridad`,
        coinsCP3: `Para realizar una compra en ChatMurcianys debes estar registrado
    como un usuario de ChatMurcianys y cumplir con esta Política de Monedas (incluyendo
    la <a href="#privacy">Política de Privacidad</a> y la
    política de <a href="#terms">Términos y condiciones</a>. Reconoces
    que eres responsable de mantener la seguridad de, y
    restringir el acceso a tu cuenta y contraseña. Tambien estas de acuerdo
    en aceptar la responsabilidad de todas las compras y otras actividades
    que ocurren bajo tu cuenta. ChatMurcianys vende sus Productos Auxiliares
    y Servicios sólo a aquellos usuarios que legalmente pueden hacer
    compras con tarjeta de crédito. Si tienes entre 13 años
    y 18 (o la mayoría de edad legal en su estado de residencia),
    puedes realizar compras en ChatMurcianys solo con el permiso
    de un padre o tutor. ChatMurcianys se reserva el derecho de
    rechazar, cancelar pedidos o cancelar cuentas, en cualquier momento en su
    sola discreción.`,
        coinsCP4: `ChatMurcianys puede ofrecer ciertos Productos y Servicios Auxiliares
    como monedas, que son artículos digitales (moneda virtual) que
    permiten a los usuarios activar o acceder a otros elementos o servicios virtuales
    en la Plataforma que pueden estar disponible en la Plataforma de vez en cuando. Las monedas no tienen valor monetario (es decir, no son una cuenta de efectivo
    o equivalente), y no constituyen moneda ni propiedad de ningún
    tipo. Las monedas no se pueden vender ni transferir a otros Usuarios, y
    no se puede canjear por dinero en efectivo ni por ningún otro bien o servicio.
    Los usuarios no tienen propiedad, patentado, propiedad intelectual,
    posesión o interés monetario en Monedas promocionales o compradas,
    que siguen siendo contenidos digitales de ChatMurcianys sujetos a
    ChatMurcianys <a href="#terms">Términos y Condiciones</a>. Las monedas son
    No reembolsable. ChatMurcianys no reconoce la cesión de
    Monedas (incluso por dinero o cualquier otra consideración o artículos de
    valor ya sea dentro o fuera de ChatMurcianys). No deberas
    comprar, vender, intercambiar o intercambiar Monedas, u ofrecer comprar,
    vender o intercambiar monedas. Cualquier intento de transferencia será nulo
    y vacío. Las monedas solo se pueden usar en ChatMurcianys como una forma de
    activar o acceder a otros artículos o servicios virtuales que pueden ser
    disponible en ChatMurcianys de vez en cuando.`,
        coinsCP5: `ChatMurcianys no garantiza que las Monedas estén disponibles en
    todos los tiempos o en cualquier momento dado. ChatMurcianys no garantiza
    que continuaremos ofreciendo Monedas para cualquier duración particular de
    tiempo. ChatMurcianys puede modificar las Monedas a nuestro exclusivo criterio, y
    tales modificaciones pueden hacer que las Monedas sean más o menos comunes, deseables,
    eficaz o funcional. ChatMurcianys puede suspender o terminar
    Monedas por cualquier motivo o sin él, a nuestro exclusivo criterio, y sin
    preaviso o responsabilidad.`,
        coinsCP6: `La cantidad de monedas que se necesitan para activar o acceder a Los artículos Virtuales
    (regalos) se le mostrará cuando intente comprar
    tales regalos. Antes de comprar Monedas, comprueba cuántas necesitas. El costo
    por moneda difiere según la cantidad que compre a la vez. Nosotros
    te aclararemos el precio total del paquete de monedas cuando
    compre monedas. Puedes realizar un seguimiento de tus gastos en monedas, y
    cómo los usas para acceder a Regalos, usando las siguientes herramientas:`,
        coinsTL1: `El número total de monedas (Balance de monedas) se actualizará cada
    vez que compras Monedas o las usas a cambio de Artículos Virtuales. El balance de su cuenta se muestra en el menú de su Página de Inicio
    (<i class="fa-solid fa-bars"></i> > Balance > Recargas)
    y en cualquier momento que estés a punto de usar Monedas para activar o acceder
    elementos virtuales;`,
        coinsTL2: `En tu Balance, puedes ver tu historial de Recargas que muestra
    cuántas monedas has comprado;`,
        coinsTL3: `En la sección Regalos de tu Balance, también puedes ver cómo
    has usado las Monedas en ChatMurcianys seleccionando la opción Enviado.`,
        coinsCP7: `Enviando regalos`,
        coinsCP8: `Los regalos son elementos virtuales que se pueden activar con monedas.`,
        coinsCP9: `Puedes enviar regalos para interactuar y mostrar tu aprecio por
    el contenido de ChatMurcianys de acuerdo con nuestros
    <a href="#terms">Términos y condiciones</a>. Cuando envías un regalo,
    otros usuarios en ChatMurcianys pueden ver tu nombre de usuario, imagen de perfil
    (si se proporciona) y los detalles del Regalo que envió.
    Al enviar Regalos, no estás transfiriendo dinero a otros usuarios de
    ChatMurcianys. En cambio, el tipo y número de regalos enviados es un
    factor utilizado por ChatMurcianys en el cálculo de la cantidad de Rubíes
    que se otorgará a los creadores de dicho contenido, junto con
    otros factores, que pueden aplicarse. Los rubíes se pueden utilizar para
    obtener dinero de ChatMurcianys de acuerdo con nuestra
    <a href="#gifts-policy">Política de regalos</a>`,
        coinsCP10: `Debido a que los regalos se activan automáticamente con efecto inmediato,
    no son retornables ni reembolsables por Monedas o dinero.`,
        coinsCP11: `Compra de monedas`,
        coinsCP12: `Las monedas se pueden comprar a través de una tienda de aplicaciones de terceros (Google
      Play Store). ChatMurcianys puede permitir formas adicionales de obtener
      Monedas a su discreción.`,
        coinsCP13: `En el caso de que la cantidad incorrecta de Monedas sea acreditada a su
      Balance de la cuenta, puede comunicarse con nosotros y corregiremos el
      error lo antes posible.`,
        coinsCP14: `Si ocurre un problema con su método de pago (se rechaza el pago)
      su pedido será cancelado automáticamente. No somos responsables
      por cualquier problema entre usted y el emisor de su tarjeta, banco u otro
      proveedor de servicios de pago.`,
        coinsCP15: `Si compra monedas a través de una tienda de aplicaciones de terceros (Google Play
        Store), entonces se aplican los términos de la tienda correspondientes a las compras desde la aplicación.`,
        coinsCP16: `Reembolsos`,
        coinsCP17: `Si compró Monedas a través de una tienda de aplicaciones de terceros (Google
      Play Store), entonces deberá ponerse en contacto con la tienda de aplicaciones correspondiente
      sobre reembolsos. ChatMurcianys no puede proporcionarte un reembolso
      a menos que las Monedas estén defectuosas. Para desistir de su compra de
      Monedas, contáctenos para que podamos ayudarle con cualquier error que
      puede estar enfrentando con la compra de las Monedas.`,
        giftsCP1: `Esta Política de Regalos se aplica a los usuarios de ChatMurcianys que
      participan en el programa de Regalos que incentivan a los usuarios a
      interactuar con ChatMurcianys. "Regalos" significa contenido digital como
      Rubíes y emoticonos que puedan estar disponibles;`,
        giftsCP2: `Elegibilidad`,
        giftsCP3: `Para participar en el programa debes tener al menos 13 años de edad
    y registrar una estación de radio válida y debe ser aprobada por
    ChatMurcianys. Otras opciones de participación elegibles pueden ser
    disponible en el futuro. Si tienes entre 13 y 18 años
    (o entre los 13 y la mayoría de edad legal en su país de
    residencia), solo puede participar en el Programa bajo la
    supervisión de un padre o tutor legal que acepte estar obligado
    por este Acuerdo. Determinaremos su elegibilidad a nuestro exclusivo
    discreción. Los propietarios de estaciones de radio aprobadas tendrán la opción de
    participar en el programa anunciando su transmisión en vivo en
    ChatMurcianys (Anuncia emisión en vivo) y marcando la opción "Permitir que la audiencia envíe regalos."`,
        giftsCP4: `Si decidimos rechazar su participación o cancelar su cuenta
    en conexión con cualquier violación o abuso, incluyendo, pero no
    limitado a cualquier violación de los
    <a href="#terms">Términos y Condiciones</a> y la Comunidad
    Directrices como se establece en la
    <a href="#privacy">Política de privacidad</a> no puede intentar
    volver a unirse al Programa sin nuestra autorización previa por escrito.`,
        giftsCP5: `Requisitos de conformidad`,
        giftsCP6: `Se asegurará de que la información asociada a su cuenta
    son en todo momento completos, exactos y actualizados. Usted también debe
    cumplir con nuestros <a href="#terms">Términos y Condiciones</a> y
    <a href="#privacy">Política de Privacidad</a>. Además, usted acepta
    los siguientes acuerdos de cumplimiento con nuestro actual Programa de Regalos elegibles:`,
        giftsE1: `Estaciones de Radio:`,
        giftsE2: `El Dueño y/o Locutores de la Emisora serán los únicos
    que podrán recibir y reclamar los Regalos regalados por
    su audiencia a través de ChatMurcianys. Las palabras Dueño y
    Locutores se refiere a cualquier persona que tiene una asociación directa o tiene un
    rol con el funcionamiento de la entidad de la Emisora. Es
    decir, son el usuario que registró la Emisora de Radio, el
    usuario(s) que administran, gestionan o albergan la estación de radio y
    que tienen permiso (expresado y profesado por el Dueño
    de la Emisora de Radio a través de la plataforma de ChatMurcianys) para
    comprometerse con la identidad de la estación de radio.`,
        giftsE3: `ChatMurcianys, a su sola discreción, puede hacer Regalos
    disponibles para que usted muestre, presente o use de otro modo en su
    sala de chat, o por otros medios. Estos regalos se utilizarán para
    apoyar la transmisión de su Radio para celebrar momentos
    y expresar su aprecio por el Locutor usando la función "Enviar regalo"
    en ChatMurcianys.`,
        giftsCP7: `Los regalos recibidos se convertirán en Rubíes. Cuando los regalos
    están en rubíes, se pueden usar para obtener dinero. Usted recibirá
    un centavo estadounidense ($0.01) por rubí que un usuario utilize para expresar
    su apoyo a través del chat u otros medios a través de
    ChatMurcianys. La Política de Regalos puede ser ajustada por ChatMurcianys, a su sola discreción, incluyendo, para Rubíes recibidos
    por los usuarios con carácter promocional, comprados en diferentes locales
    jurisdicciones o según sea necesario para evitar daños a
    Intereses comerciales de ChatMurcianys. Además, ChatMurcianys podrá
    determinar no proporcionarle Rubíes para ningún uso de Rubíes
    que no es consistente con la Política de regalos. ChatMurcianys
    se reserva el derecho de dejar de ofrecer o apoyar Regalos y/o
    Rubíes en cualquier momento.`,
        wdCP1: `Esta Política de Retiro se aplica a los Usuarios de ChatMurcianys que
    participan en el Programa de Regalos y optan por retirar su
    ganancias (Rubíes) a través de ChatMurcianys.`,
        wdCP2: `Para retirar sus ganancias, debe utilizar uno de los métodos de retiro que admitimos actualmente:`,
        wdCP3: `El pago se enviará a la cuenta externa que seleccione en
    de acuerdo con las reglas del proveedor del método de pago. Nosotros
    reservamos el derecho de exigir que esta cuenta se registre en su
    propio nombre. Usted está sujeto a todos los términos y condiciones de la
    forma de pago que elija. Todos los pagos deben hacerse en
    Dólares estadounidenses, excepto donde se ofrezcan otras monedas
    a través de los medios de pago puestos a su disposición por ChatMurcianys.`,
        wdCP4: `Debe asegurarse de que la información que proporciona es precisa,
    completa y actualizada. Usted será el único responsable de cualquier
    consecuencia derivada de proporcionar datos inexactos o información incompleta. Podemos verificar su información de pago y
    elegibilidad para coleccionar Rubíes o recibir pagos, tales como
    identidad, edad y ubicación. Si hay información adicional
    requerida, usted acepta proporcionarnos dicha información al ser
    solicitada.`,
        wdCP5: `Se aplican los siguientes mínimos y máximos de retiro:`,
        wdM1: `Retiro mínimo`,
        wdM2: `Paypal: $50.00`,
        wdM3: `Zelle: $50.00`,
        wdM4: `El retiro máximo diario es equivalente a $1,000 en dólares estadounidenses`,
        wdCP6: `Tarifas de transacción`,
        wdCP7: `Los métodos de retiro externos que admite actualmente ChatMurcianys pueden imponer una tarifa de transacción adicional. Si se impone una tarifa de transacción, se deducirá de cada pago de retiro antes de que llegue a la cuenta externa de su elección.`,
        wdCP8: `Podemos, por razones de seguridad y/o para mantener la integridad de su cuenta, suspender su capacidad de usar Rubíes para obtener un pago. Nos pondremos en contacto con usted si tenemos que hacer esto. Cuando necesitemos realizar cambios urgentes por motivos de seguridad, legales o reglamentarios, es posible que no podamos avisarle con anticipación, pero se lo haremos saber tan pronto como podamos. Si cree que hemos cometido un error al suspender su capacidad de usar Rubíes para obtener un pago, contáctenos.`,
        wdCP9: `No somos responsables de ninguna pérdida o daño causado por los proveedores de métodos de pago, siempre que no sea como resultado de nuestras acciones.`,
        wdCP10: `Todos los pagos incluirán impuestos (si corresponde). Si está sujeto a algún impuesto sobre los pagos, será responsable del pago de dichos impuestos.`,
        wdCP11: `Podemos cambiar o alterar esta política en cualquier momento por razones legales, reglamentarias o comerciales. Estos cambios pueden incluir quién puede participar en el Programa de regalos, cómo se cobran o utilizan los pagos. Estas modificaciones podrán realizarse sin previo aviso, a exclusivo criterio de ChatMurcianys. Si se realizan cambios, podemos proporcionar un aviso enviando un correo electrónico, publicando un aviso en ChatMurcianys o publicando en las redes sociales de ChatMurcianys. Por favor revise estos términos periódicamente para esos cambios. Cualquier término modificado se aplicará a cualquier compra realizada después de que dichos cambios se publiquen en ChatMurcianys. Por lo tanto, debe revisar estos términos antes de cada compra o retiro para comprender los términos aplicables a dicha transacción. Si no está de acuerdo con estos términos, no realice compras ni retiros en ChatMurcianys.`,
        polUpdated: "Actualizado: 7/20/2023",
        inaContent: "Contenido inapropiado",
        inaSum: "Para respaldar la seguridad, la protecci\xf3n y la integridad de nuestros servicios, tomaremos las medidas apropiadas contra personas o actividades abusivas que violen nuestros T\xe9rminos y condiciones. Prohibimos el uso indebido de nuestros servicios y cualquier contenido que sea da\xf1ino o inapropiado para nuestros usuarios, incluyendo las siguientes acciones:",
        spam: "Contenido no deseado/spam",
        sexualContent: "Contenido sexual",
        hateSpeech: "Discurso de odio",
        violence: "Violencia",
        senEvents: "Eventos sensibles",
        bullying: "Acoso y agresion",
        dangerProds: "Produtos peligrosos",
        falseinfo: "Informaci\xf3n falsa",
        unaSales: "Ventas no autorizadas"
    }
};
function translatePage(lang) {
    var translate = false;
    if (lang) {
        if (lang.includes("es")) {
            if (trans && trans.idiom == "Es") return;
            trans = language.es;
            document.getElementsByTagName("html")[0].setAttribute("lang", "es");
            var langs = langDropdown.querySelectorAll("a");
            langs[0].className = langs[0].className.replace(" set", "");
            langs[1].className += " set";
            (0, _common.setCookie)("lang", "es", 365);
        } else {
            if (trans && trans.idiom == "En") return;
            trans = language.eng;
            document.getElementsByTagName("html")[0].setAttribute("lang", "en");
            var langs = langDropdown.querySelectorAll("a");
            langs[0].className += " set";
            langs[1].className = langs[1].className.replace(" set", "");
            (0, _common.setCookie)("lang", "en", 365);
        }
        translate = true;
    } else if ((0, _common.getCookie)("lang") != "") {
        if ((0, _common.getCookie)("lang").includes("es")) {
            trans = language.es;
            document.getElementsByTagName("html")[0].setAttribute("lang", "es");
            var langs = langDropdown.querySelectorAll("a");
            langs[0].className = langs[0].className.replace(" set", "");
            langs[1].className += " set";
            translate = true;
            (0, _common.setCookie)("lang", "es", 365);
        } else trans = language.eng;
    } else if (navigator.language && navigator.language.includes("es")) {
        trans = language.es;
        document.getElementsByTagName("html")[0].setAttribute("lang", "es");
        var langs = langDropdown.querySelectorAll("a");
        langs[0].className = langs[0].className.replace(" set", "");
        langs[1].className += " set";
        translate = true;
    } else trans = language.eng;
    if (translate) {
        menuLang.textContent = trans.idiom;
        navChat.textContent = trans.Chat;
        navFeat.textContent = trans.Feat;
        navDownload.textContent = trans.Download;
        navAbout.textContent = trans.About;
        resChat.textContent = trans.Chat;
        resFeat.textContent = trans.Feat;
        resDownload.textContent = trans.Download;
        resAbout.textContent = trans.About;
        var lists = document.querySelector(".stSection").querySelectorAll("a");
        lists[0].textContent = trans.a0;
        lists[1].textContent = trans.a1;
        lists[2].textContent = trans.a2;
        lists[3].textContent = trans.a3;
        lists[4].textContent = trans.a4;
        lists[5].textContent = trans.deletingData;
        lists[6].textContent = trans.deletingAcc;
        lists[7].textContent = trans.a5;
        lists[8].textContent = trans.a6;
        lists[9].textContent = trans.coinsPolicy;
        lists[10].textContent = trans.giftsPolicy;
        lists[11].textContent = trans.wdPolicy;
        lists[12].textContent = trans.a7;
        lists[13].textContent = trans.a8;
        lists[14].textContent = trans.a9;
        lists[15].textContent = trans.a10;
        var h3s = document.querySelectorAll("h3");
        h3s[0].textContent = trans.a0;
        h3s[1].textContent = trans.a1;
        h3s[2].textContent = trans.a2;
        h3s[3].textContent = trans.infoCole;
        h3s[4].textContent = trans.a4;
        h3s[5].textContent = trans.deletingData;
        h3s[6].textContent = trans.deletingAcc;
        h3s[7].textContent = trans.a5;
        h3s[8].textContent = trans.a6;
        h3s[9].textContent = trans.coinsPolicy;
        h3s[10].textContent = trans.giftsPolicy;
        h3s[11].textContent = trans.wdPolicy;
        h3s[12].textContent = trans.a7;
        h3s[13].textContent = trans.links;
        h3s[14].textContent = trans.child;
        h3s[15].textContent = trans.changes;
        h3s[16].textContent = trans.terms;
        h3s[17].textContent = trans.changeTerms;
        h3s[18].textContent = trans.a9;
        h3s[19].textContent = trans.a10;
        var pList = document.querySelectorAll("p:not(.vtPol)");
        console.log("length: " + pList.length);
        pList[0].textContent = trans.sumAbout;
        pList[1].textContent = trans.sumMission;
        pList[2].textContent = trans.sumPol1;
        pList[3].textContent = trans.sumPol2;
        pList[4].textContent = trans.sumPol3;
        pList[5].textContent = trans.sumPol4;
        pList[6].textContent = trans.infoCol1;
        pList[7].textContent = trans.infoCol2;
        pList[8].textContent = trans.infoCol3;
        pList[9].textContent = trans.logSum;
        pList[10].textContent = trans.dataSum;
        pList[11].querySelector("span").textContent = trans.dAccSum1;
        pList[12].textContent = trans.dAccSum2;
        pList[13].textContent = trans.dAccSum3;
        pList[14].querySelector("span").textContent = trans.dAccSum4;
        pList[15].textContent = trans.cookieSum1;
        pList[16].textContent = trans.cookieSum2;
        pList[17].textContent = trans.servSum;
        pList[18].textContent = trans.reasonP;
        pList[19].textContent = trans.securitySum;
        pList[20].textContent = trans.inaSum;
        pList[21].textContent = trans.otherSum;
        pList[22].textContent = trans.childSum;
        pList[23].innerHTML = trans.changesSum;
        pList[24].innerHTML = trans.changesSum2;
        pList[25].textContent = trans.termSum1;
        pList[26].textContent = trans.termsSum2;
        pList[27].textContent = trans.termsSum3;
        pList[28].textContent = trans.termsSum4;
        pList[29].textContent = trans.termsSum5;
        pList[30].textContent = trans.termsSum6;
        pList[31].textContent = trans.termsSum7;
        pList[32].textContent = trans.termsSum8;
        pList[33].innerHTML = trans.changesTermSum;
        pList[34].innerHTML = trans.contactSum1;
        pList[35].textContent = trans.contactSum2;
        var reasons = rList.querySelectorAll("li");
        reasons[0].textContent = trans.reason1;
        reasons[1].textContent = trans.reason2;
        reasons[2].textContent = trans.reason3;
        reasons[3].textContent = trans.reason4;
        var coinsContentList = document.querySelectorAll("#div-coins-content p.vtPol");
        coinsContentList[0].innerHTML = trans.coinsCP1;
        coinsContentList[1].innerHTML = trans.coinsCP2;
        coinsContentList[2].innerHTML = trans.coinsCP3;
        coinsContentList[3].innerHTML = trans.coinsCP4;
        coinsContentList[4].innerHTML = trans.coinsCP5;
        coinsContentList[5].innerHTML = trans.coinsCP6;
        var coinToolList = document.querySelectorAll("#coinToolList li");
        coinToolList[0].innerHTML = trans.coinsTL1;
        coinToolList[1].innerHTML = trans.coinsTL2;
        coinToolList[2].innerHTML = trans.coinsTL3;
        coinsContentList[6].innerHTML = trans.coinsCP7;
        coinsContentList[7].innerHTML = trans.coinsCP8;
        coinsContentList[8].innerHTML = trans.coinsCP9;
        coinsContentList[9].innerHTML = trans.coinsCP10;
        coinsContentList[10].innerHTML = trans.coinsCP11;
        coinsContentList[11].innerHTML = trans.coinsCP12;
        coinsContentList[12].innerHTML = trans.coinsCP13;
        coinsContentList[13].innerHTML = trans.coinsCP14;
        coinsContentList[14].innerHTML = trans.coinsCP15;
        coinsContentList[15].innerHTML = trans.coinsCP16;
        coinsContentList[16].innerHTML = trans.coinsCP17;
        var giftsContentList = document.querySelectorAll("#div-gifts-content p.vtPol");
        giftsContentList[0].innerHTML = trans.giftsCP1;
        giftsContentList[1].innerHTML = trans.giftsCP2;
        giftsContentList[2].innerHTML = trans.giftsCP3;
        giftsContentList[3].innerHTML = trans.giftsCP4;
        giftsContentList[4].innerHTML = trans.giftsCP5;
        giftsContentList[5].innerHTML = trans.giftsCP6;
        giftsContentList[6].innerHTML = trans.giftsE1;
        giftsContentList[7].innerHTML = trans.giftsE2;
        giftsContentList[8].innerHTML = trans.giftsE3;
        giftsContentList[9].innerHTML = trans.giftsCP7;
        var wdContentList = document.querySelectorAll("#div-wd-content p.vtPol");
        wdContentList[0].innerHTML = trans.wdCP1;
        wdContentList[1].innerHTML = trans.wdCP2;
        wdContentList[2].innerHTML = trans.wdCP3;
        wdContentList[3].innerHTML = trans.wdCP4;
        wdContentList[4].innerHTML = trans.wdCP5;
        var wdMinMaxList = document.querySelectorAll("#ul-wd-min li");
        wdMinMaxList[0].innerHTML = trans.wdM1;
        wdMinMaxList[1].innerHTML = trans.wdM2;
        wdMinMaxList[2].innerHTML = trans.wdM3;
        wdMinMaxList[3].innerHTML = trans.wdM4;
        wdContentList[5].innerHTML = trans.wdCP6;
        wdContentList[6].innerHTML = trans.wdCP7;
        wdContentList[7].innerHTML = trans.wdCP8;
        wdContentList[8].innerHTML = trans.wdCP9;
        wdContentList[9].innerHTML = trans.wdCP10;
        wdContentList[10].innerHTML = trans.wdCP11;
        document.getElementById("policy-update").innerHTML = trans.polUpdated;
        var inaActionList = document.getElementById("inaActionList");
        var inaList = inaActionList.querySelectorAll("li");
        inaList[0].textContent = trans.spam;
        inaList[1].textContent = trans.sexualContent;
        inaList[2].textContent = trans.hateSpeech;
        inaList[3].textContent = trans.violence;
        inaList[4].textContent = trans.senEvents;
        inaList[5].textContent = trans.bullying;
        inaList[6].textContent = trans.dangerProds;
        inaList[7].textContent = trans.falseinfo;
        inaList[8].textContent = trans.unaSales;
        let ulDeleteList = document.getElementById("dAccList").querySelectorAll("li");
        ulDeleteList[0].textContent = trans.dAccLi1;
        ulDeleteList[1].textContent = trans.dAccLi2;
        ulDeleteList[2].textContent = trans.dAccLi3;
        ulDeleteList[3].textContent = trans.dAccLi4;
    }
}

},{"./common":"loJev"}]},["7yuPK"], "7yuPK", "parcelRequire460e")

//# sourceMappingURL=about.bf332fda.js.map
